(function () {
    'use strict';
    angular.module('blocks.service.users', ['angular-cache', 'services.api']);
})();
